var status = false;
$('head').append('<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.9.0/slick.min.css" type="text/css" />');
$('head').append('<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.9.0/slick-theme.min.css" type="text/css" />');
if (jQuery == undefined) {
    $("head").append($("<script />", {
        src: "//code.jquery.com/jquery-2.1.4.min.js"
    }));
}

var script = document.createElement("script");
script.type = "text/javascript";
script.src = "https://cdn.jsdelivr.net/jquery.slick/1.5.0/slick.min.js";

var script1 = document.createElement("script");
script1.type = "text/javascript";
script1.src = "https://apps.techdignity.com/recent-viewed-products/public/js/api.jquery.js";

var script2 = document.createElement("script");
script2.type = "text/javascript";
script2.src = "https://cdnjs.cloudflare.com/ajax/libs/jquery-cookie/1.4.1/jquery.cookie.min.js";

$("head").append(script);
$("head").append(script1);
$("head").append(script2);

status = true;
if (jQuery.cookie == undefined) {
/*    $("head").append($("<script />", {
        type: "text/javascript",
        defer: "defer",
        src: "//cdnjs.cloudflare.com/ajax/libs/jquery-cookie/1.4.1/jquery.cookie.min.js"
    }));                        
*/
//$("head").append(script2);
/*! jquery.cookie v1.4.1 | MIT */
!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):"object"==typeof exports?a(require("jquery")):a(jQuery)}(function(a){function b(a){return h.raw?a:encodeURIComponent(a)}function c(a){return h.raw?a:decodeURIComponent(a)}function d(a){return b(h.json?JSON.stringify(a):String(a))}function e(a){0===a.indexOf('"')&&(a=a.slice(1,-1).replace(/\\"/g,'"').replace(/\\\\/g,"\\"));try{return a=decodeURIComponent(a.replace(g," ")),h.json?JSON.parse(a):a}catch(b){}}function f(b,c){var d=h.raw?b:e(b);return a.isFunction(c)?c(d):d}var g=/\+/g,h=a.cookie=function(e,g,i){if(void 0!==g&&!a.isFunction(g)){if(i=a.extend({},h.defaults,i),"number"==typeof i.expires){var j=i.expires,k=i.expires=new Date;k.setTime(+k+864e5*j)}return document.cookie=[b(e),"=",d(g),i.expires?"; expires="+i.expires.toUTCString():"",i.path?"; path="+i.path:"",i.domain?"; domain="+i.domain:"",i.secure?"; secure":""].join("")}for(var l=e?void 0:{},m=document.cookie?document.cookie.split("; "):[],n=0,o=m.length;o>n;n++){var p=m[n].split("="),q=c(p.shift()),r=p.join("=");if(e&&e===q){l=f(r,g);break}e||void 0===(r=f(r))||(l[q]=r)}return l};h.defaults={},a.removeCookie=function(b,c){return void 0===a.cookie(b)?!1:(a.cookie(b,"",a.extend({},c,{expires:-1})),!a.cookie(b))}});
}

var lastPart = window.location.href.split("/").pop();
var pathname = window.location.pathname;
var isProducts = pathname.split('/')[1];
var isCollection = pathname.split('/')[1];
//console.log(isProducts+'=='+isCollection); 

var isCollectionWithProduct = pathname.split('/')[3];
var productCount = 0;
$(document).ready(function () {
	setTimeout(function(){
    if (isProducts == "products" || isProducts == "cart" || (isCollection == "collections" && isCollectionWithProduct == "products") || isCollection == "collections") {
        var pHandle = lastPart;
        
        $.ajax({
            url: "https://apps.techdignity.com/recent-viewed-products/public/recent_viewed_products",
            data: {
                shopname: Shopify.shop
            },
            success: function (data) { 
                //alert('het');
                var pHandle = lastPart;
                var objectData = jQuery.parseJSON(data);
                var obj = objectData.data;
                var currency = objectData.currency;
                var enable_app = obj.enable_app;
                var store_id = obj.store_id;
                var title = obj.title;
                var number_of_products = obj.number_of_products;
                var enable_truncate_title = obj.truncate_product_title;
                var truncate_product_title_limit = obj.truncate_product_title_limit;
                var enable_price = obj.show_hide_price;
                var enable_buy_now_button = obj.enable_buy_now_button;
                var buy_now_text = obj.buy_now_text;
                var section_title_font_size = obj.section_title_font_size;
                var display_homepage = obj.display_homepage;
                var display_collectionpage = obj.display_collectionpage;
                var display_productpage = obj.display_productpage;
                var display_cartpage = obj.display_cartpage;
                var image_size = obj.image_size;                
                var buynow_btn_bg_color = obj.buynow_btn_bg_color;
                var currency_symbol = obj.store_currency;
                //console.log(currency_symbol);
                
                var flag = false;
                if (isProducts == 'cart') {
                    if (display_cartpage == true)
                        var flag = true;
                    else
                        var flag = false;

                } else if (isProducts == 'products' || isCollection == "collections" || (isCollection == "collections" && isCollectionWithProduct == "products")) {
                    if (display_productpage == true)
                        var flag = true;
                    else
                        var flag = false;
                }
                 
                if (enable_app == 1) {
                    
                    $("head").append('<style type="text/css"> #tech-dignity-recent-view .title-head h1{text-align:center;margin-bottom: 15px;} .td-slider-wrapper{ margin: 0 auto;}.td-slider-wrapper ul.slides{display: inline-block;width: 100%;padding:0px;} .td-slider-wrapper ul li{float: left;width: 25%;text-align: center;} .td-slider-wrapper ul li .td-item-content{ text-align: center; margin-top: 15px; } .td-slider-wrapper ul li .td-title a{ color: #000000; font-size: 14px; font-weight: 700; } .td-slider-wrapper ul li .td-buy-now-box{ padding-top: 20px; padding-bottom: 20px; } .td-slider-wrapper ul li .td-buy-now-box .td-buy-now{ padding: 15px 30px;color: #fff; text-decoration: none; }.td-flexslider ul li.product-box .item a img{width:240;height:180px;max-width:100%;margin:0 auto}.td-flexslider .flex-direction-nav a:before{font-size: 34px;}.slick-next:before,.slick-prev:before{opacity:1!important;font-size:40px!important;color:#000}button.slick-next.slick-arrow,button.slick-prev.slick-arrow{top:35%!important}.slick-prev{left:-45px!important}  </style>');
                    $("head").append('<style>.td-buy-now-box a.td-buy-now{background-color:'+buynow_btn_bg_color+'}</style>');
                    if (isProducts == 'cart') {
                    	
                    $("<div id='tech-dignity-recent-view'></div>").insertBefore($("#shopify-product-reviews"));	
                    	

                    } else if(isProducts == 'products'){
                      
                    $("<div id='tech-dignity-recent-view'></div>").insertBefore($("#shopify-product-reviews"));  
                    }else if (isCollection == 'collections') {
                      
                      
                    $("<div id='tech-dignity-recent-view'></div>").insertAfter($("#shopify-product-reviews"));  
                        
                    }
                                       
                    $("#tech-dignity-recent-view").append('<div class="title-head"></div><section class="slider td-slider-wrapper td-recentview-product"><div class="td-flexslider flexslider carousel"><ul class="slides"></ul></div></section>');
                   

                    if (jQuery.cookie == undefined) {
                       
                        !function(a){"function"==typeof define&&define.amd?define(["jquery"],a):"object"==typeof exports?a(require("jquery")):a(jQuery)}(function(a){function b(a){return h.raw?a:encodeURIComponent(a)}function c(a){return h.raw?a:decodeURIComponent(a)}function d(a){return b(h.json?JSON.stringify(a):String(a))}function e(a){0===a.indexOf('"')&&(a=a.slice(1,-1).replace(/\\"/g,'"').replace(/\\\\/g,"\\"));try{return a=decodeURIComponent(a.replace(g," ")),h.json?JSON.parse(a):a}catch(b){}}function f(b,c){var d=h.raw?b:e(b);return a.isFunction(c)?c(d):d}var g=/\+/g,h=a.cookie=function(e,g,i){if(void 0!==g&&!a.isFunction(g)){if(i=a.extend({},h.defaults,i),"number"==typeof i.expires){var j=i.expires,k=i.expires=new Date;k.setTime(+k+864e5*j)}return document.cookie=[b(e),"=",d(g),i.expires?"; expires="+i.expires.toUTCString():"",i.path?"; path="+i.path:"",i.domain?"; domain="+i.domain:"",i.secure?"; secure":""].join("")}for(var l=e?void 0:{},m=document.cookie?document.cookie.split("; "):[],n=0,o=m.length;o>n;n++){var p=m[n].split("="),q=c(p.shift()),r=p.join("=");if(e&&e===q){l=f(r,g);break}e||void 0===(r=f(r))||(l[q]=r)}return l};h.defaults={},a.removeCookie=function(b,c){return void 0===a.cookie(b)?!1:(a.cookie(b,"",a.extend({},c,{expires:-1})),!a.cookie(b))}});
                    }

                    var pHandle;
                    if (isProducts == "products") {
                        pHandle = lastPart;
                    }
                    $(".title-head h1").css("font-size", section_title_font_size + "px");
                    var pLimit = number_of_products;
                    var pPointer = 0;
                    
                    if ($.cookie('tech-dignity-recent-view') == undefined) {
                        if (pHandle) {
                            $.cookie('tech-dignity-recent-view', lastPart, {
                                expires: 365,
                                path: "/"
                            });
                        }
                    }
                    
                    var currentProducts = [];
                    if ($.cookie('tech-dignity-recent-view') != undefined) {
                        currentProducts = $.cookie('tech-dignity-recent-view').split(",");
                    }
                    if (currentProducts.length > 0) {
                        $('#_rvp').show()
                    }
                    // set the current product
                    // If its not already listed
                    if (currentProducts.indexOf(pHandle) == -1) {
                        // If we are at the limit move it to the front
                        if (currentProducts.length >= pLimit) {
                            currentProducts.unshift; // remove very last item
                        }
                        currentProducts.push(pHandle); // add this one
                    }
                    var newArray = currentProducts.filter(function (v) {
                        return v !== ''
                    });
                    // prevent cookie override.
                    if (newArray.length > 0) {
                        jQuery.cookie('tech-dignity-recent-view', newArray.join(","), {
                            expires: 365,
                            path: "/"
                        });
                    }
                    //$("#rv__spinner").hide();                                        
                    $.each(newArray.reverse(), function (i, e) {                    	
                        if (pPointer >= pLimit || e == '') {
                            return false;
                        } else {
                            pPointer += 1;
                            Shopify.getProduct(e, function (product) {     
                              
                              
                              var wcpcartdata = [];
          var xhttp = new XMLHttpRequest();
          xhttp.onreadystatechange = function() {
            if (this.readyState == 4 && this.status == 200) {      
              wcpcartdata=JSON.parse(this.responseText);
            }
          };
          xhttp.open("GET", '/search/?view=wcp_discount_api&handle='+product.handle, false);
          xhttp.send();
                              
                              product.price=wcpcartdata.products[0].wpd_price
                            	var slide_pro_url = '';
                            	if(product.url){
                                	var parts = product.url.split("/");
                                	slide_pro_url = parts[parts.length - 1];
                            	}else{
                            		slide_pro_url = product.handle;
                            	}
                                if (pHandle != slide_pro_url && slide_pro_url != undefined) {                                   	
                                	productCount++;

                                	if(productCount == 1){										
                                                $(".title-head").append('<div class="title-head"><h1 class="td-center">' + title + '</h1></div>');
					}

                                    if (parseInt(enable_truncate_title) == 1) {
                                        var truncated_title = product.title.substring(0, truncate_product_title_limit);
                                        truncated_title = truncated_title + "...";
                                    } else {
                                        var truncated_title = product.title;
                                    }                                    
                                    // we now have the product
                                    var productContainer = $("<li />", {
                                        class: "product-box"
                                    });
                                    var productBox = $("<div />", {
                                        class: "item"
                                    });
                                    var productImg = $("<div />", {
                                        class: "rv-product-img"
                                    });
                                    var plink = $("<a />", {
                                        alt: product.title,
                                        title: product.title,
                                        href: product.url
                                    });
                                    //alert(product.title);
                                    var plink2 = $("<a />", {
                                        alt: product.title,
                                        title: product.title,
                                        href: product.url,
                                        html: truncated_title
                                    });
                                    var pTitle = $("<label/>", {
                                        class: "td-title"
                                    });

                                    var item_content = $("<div/>", {
                                        class: "td-item-content"
                                    });
                                    var item_addtocart_box = $("<div/>", {
                                        class: "td-buy-now-box"
                                    });
                                    //alert(product.featured_image);
                                    //console.log(product.featured_image);
                                    //var pImage = ''; 
                                    var pImage = $("<img />", { 
                                        class: "rv__responsive",
                                        src: resizeImage(product.featured_image, image_size)
                                    });
                                    var pImageWrap = $("<div />", {
                                        class: "rv__img_wrap"
                                    });                                    

                                    var priceformate = '';
                                    //console.log('currency-'+currency);
                                    if(currency == 'GBP'){
                                        priceformate = Shopify.formatMoney(product.price, '£{{amount}}');
                                    } else if(currency == 'NGN'){
                                        priceformate = Shopify.formatMoney(product.price, 'â‚¦{{amount}}');
                                    } else if(currency == 'PHP'){
                                        priceformate = Shopify.formatMoney(product.price, '&#8369;{{amount}}');
                                    } else {
                                        //console.log('sysm---'+currency_symbol);
                                        if(currency_symbol !== "" && currency_symbol != "undefined"){
                                            priceformate = Shopify.formatMoney(product.price,currency_symbol+'{{amount}}');
                                        }else{
                                            priceformate = Shopify.formatMoney(product.price,'${{amount}}'); 
                                        }
                                    }

                                    if (enable_price == 1 && enable_price != '') {
                                        var pPrice = $("<p />", {
                                            class: "td-price sfs",
                                            html: priceformate
                                        });
                                    }


                                    if (enable_buy_now_button == 1 && buy_now_text != '') {

                                        var pAddToCart = $("<a />", {
                                            class: "td-buy-now",
                                            title: product.title,
                                            href: product.url,
                                            html: buy_now_text
                                        });

                                    }

                                    productImg.append(plink);
                                    pImageWrap.append(pImage);
                                    plink.append(pImageWrap);
                                    pTitle.append(plink2);
                                    productBox.append(productImg);

                                    item_content.append(pTitle);
                                    item_content.append(pPrice);

                                    item_addtocart_box.append(pAddToCart);

                                    item_content.append(item_addtocart_box);

                                    productBox.append(item_content);
                                    productContainer.append(productBox);                                    
                                    $(".td-slider-wrapper ul.slides").append(productContainer);
                                    //flexLoad(status);
                                    //add background color of the buy now btn
                                    //$(".td-buy-now-box a.td-buy-now").css('background-color', buynow_btn_bg_color);
                                }                                
                            });
                        }                        
                    });
					//flexLoad(status);					
                }
            }
        });
	
        
    }
}, 850);
  
  
});

function resizeImage(src, size) {
    if (size == null) {
        return src;
    }

    if (size == 'master') {
        return src.replace(/http(s)?:/, "");
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);

    if (match != null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];

        return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "")
    } else {
        return null;
    }
}

function flexLoad(status) {
    //$.when({status: true}).done(function () {
        setTimeout(function () {        	
            $('.td-flexslider ul.slides').slick({
               slidesToShow: 3,
               slidesToScroll: 1,
               arrows:true,
               dots: false,
               centerMode: true,
            });
        }, 1000);
    //});
}

